import React from "react";
import styled from "styled-components";
import Images from "../../../assets/images/Images";
import YearSelectorComponent from "../../yearSelector/YearSelectorComponent";
import RegionSelectorComponent from "../../regionSelector/RegionSelectorComponent";
import LanguageSelector from "../../languageSelector/LanguageSelector";
import {useTranslation} from "react-i18next";

const RankingsTitle = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  margin-top: 20px;
`;

const Spacer = styled.div`
    flex: ${(props: { flex: number }) => props.flex};
`;

const TopRow = styled.div`
  align-items: baseline;
  display: flex;
  flex-direction: row;
  flex: 1;

  margin-right: 10%;

  & > div:nth-child(1) {
    flex: 1;
  }
  
  @media (max-width: 480px) {
    flex: 0 1 auto;
  }
`;

const HeaderComponent: React.FC = () => {
    const { i18n } = useTranslation();
    const getCurrentLng = () => i18n.language || window.localStorage.i18nextLng || 'es';

    const image = (getCurrentLng() == 'es') ? Images.rankingsTitle : Images.rankingsTitleEnglish;

    return (
        <div className={'homeHeaderContainer'}>
            <Spacer flex={1}/>
            <div className={'homeHeaderContent'}>
                <TopRow>
                  <YearSelectorComponent />
                  <LanguageSelector isReversed={true} />
                </TopRow>
                <div className={'logoContainers'} >
                    <img src={Images.logoWhiteBgEconomics}
                         alt="Logo"
                         className={'homeEconomicsLogo'}
                    />
                </div>
                <RankingsTitle>
                  <div className={'headerR'}>
                    <img
                      src={Images.r}
                      alt='R'
                    />
                  </div>
                  <div className={'homeHeaderSubContainer'}>
                      <div className={'headerTitle'}>
                          <img
                            src={image}
                            alt='Rankings'
                          />
                      </div>
                      <RegionSelectorComponent />
                  </div>
                </RankingsTitle>
            </div>
        </div>
    )
};

export default HeaderComponent;
